const TASK_STATUS = {
    CANCELED: "canceled",
    PENDING: "pending",
    STARTED: "driver-on-way-to-origin",
    ARRIVED_FROM: "arrived-at-origin",
    ON_ROUTE: "on-route",
    DONE: "done",
} as const;

export enum TaskStatuses {
    PENDING = "PENDING",
    STARTED = "STARTED",
    ARRIVED_FROM = "ARRIVED_FROM",
    ON_ROUTE = "ON_ROUTE",
    DONE = "DONE",
    CANCELED = "CANCELED",
}

const PASSENGER_GROUP_STATUS = {
    PENDING: "passenger-is-not-there-yet",
    WAITING: "ready-for-pick-up",
    PICKED_UP: "picked-up",
    DONE: "done",
};

enum PASSENGER_STATUS {
    PENDING = "PENDING",
    WAITING = "WAITING",
    PICKED_UP = "PICKED_UP",
    DONE = "DONE",
}

const VEHICLE_STATUS = {
    IDLE: 0,
    IN_USE: 1,
    MALFUNCTIONING: 2,
    UNDER_MAINTENANCE: 3,
};

const DRIVER_STATUS = {
    WORKING: "WORKING",
    FREE_DAY: "FREE_DAY", // WEEKEND_OFF
    EXCUSED_LEAVE: "EXCUSED_LEAVE", // VACATION removed
    PUBLIC_HOLIDAY: "PUBLIC_HOLIDAY", // NONE AND FREE
    UNPAID_LEAVE: "UNPAID_LEAVE",
    ANNUAL_LEAVE: "ANNUAL_LEAVE",
    OVERTIME_PERMIT: "OVERTIME_PERMIT",
    SICK_LEAVE: "SICK_LEAVE",
    NONE: "NONE",
} as const;

export { TASK_STATUS, PASSENGER_GROUP_STATUS, PASSENGER_STATUS, VEHICLE_STATUS, DRIVER_STATUS };
